(function () {
  if (window.MidnightCountdown) return;

  var HOUR_SELECTORS = '[data-countdown-hours], [data-deals-hours], [data-bf-hours]';
  var MIN_SELECTORS = '[data-countdown-mins], [data-deals-mins], [data-bf-mins]';
  var SEC_SELECTORS = '[data-countdown-secs], [data-deals-secs], [data-bf-secs]';

  function getTimezone() {
    return (
      document.documentElement.getAttribute('data-store-timezone') ||
      'Europe/Amsterdam'
    );
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function getZonedParts(date, timeZone) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = part.value;
    });
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour === '24' ? 0 : parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second)
    };
  }

  function wallTimeToUtcMs(timeZone, year, month, day, hour, minute, second) {
    var utc = Date.UTC(year, month - 1, day, hour, minute, second);
    for (var i = 0; i < 3; i++) {
      var asZone = getZonedParts(new Date(utc), timeZone);
      var asUtc = Date.UTC(
        asZone.year,
        asZone.month - 1,
        asZone.day,
        asZone.hour,
        asZone.minute,
        asZone.second
      );
      var target = Date.UTC(year, month - 1, day, hour, minute, second);
      utc += target - asUtc;
    }
    return utc;
  }

  function msUntilNextMidnight(timeZone) {
    var tz = timeZone || getTimezone();
    var now = new Date();
    var parts = getZonedParts(now, tz);
    var noonToday = wallTimeToUtcMs(tz, parts.year, parts.month, parts.day, 12, 0, 0);
    var tomorrowParts = getZonedParts(new Date(noonToday + 24 * 60 * 60 * 1000), tz);
    return Math.max(
      0,
      wallTimeToUtcMs(
        tz,
        tomorrowParts.year,
        tomorrowParts.month,
        tomorrowParts.day,
        0,
        0,
        0
      ) - now.getTime()
    );
  }

  function getRemainingParts(timeZone) {
    var remaining = msUntilNextMidnight(timeZone);
    var totalSeconds = Math.floor(remaining / 1000);
    return {
      hours: Math.floor(totalSeconds / 3600),
      mins: Math.floor((totalSeconds % 3600) / 60),
      secs: totalSeconds % 60
    };
  }

  function unitLabel(el, fallback) {
    var label = el.getAttribute('data-unit-label');
    if (label != null && label !== '') return label;
    var match = String(el.textContent || '').match(/[^\d\s].*$/);
    return match ? match[0].trim() : fallback;
  }

  function setUnitText(nodes, value, fallbackLabel) {
    nodes.forEach(function (el) {
      var label = unitLabel(el, fallbackLabel);
      el.textContent = pad2(value) + (label ? ' ' + label : '');
    });
  }

  function updateRoot(root, timeZone) {
    var parts = getRemainingParts(timeZone);
    setUnitText(root.querySelectorAll(HOUR_SELECTORS), parts.hours, 'u');
    setUnitText(root.querySelectorAll(MIN_SELECTORS), parts.mins, 'm');
    setUnitText(root.querySelectorAll(SEC_SELECTORS), parts.secs, 's');
  }

  function updateAll() {
    var defaultTz = getTimezone();
    var scoped = document.querySelectorAll('[data-midnight-countdown]');
    if (scoped.length) {
      scoped.forEach(function (root) {
        updateRoot(root, root.getAttribute('data-timezone') || defaultTz);
      });
    }
    // Always refresh legacy/global marks (slideshow, media-grid, custom liquid)
    updateRoot(document, defaultTz);
  }

  window.MidnightCountdown = {
    getTimezone: getTimezone,
    msUntilNextMidnight: msUntilNextMidnight,
    getRemainingParts: getRemainingParts,
    update: updateAll
  };

  function start() {
    updateAll();
    window.setInterval(updateAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', updateAll);
})();
